import { Agent } from "@/api/generated";

/**
 * 表示・操作の対象にしてよい agent か。
 *
 * `Agent.id` は生成型上 optional なうえ、URL から復元した ID（`?tags=` と同様に数値化する経路）では
 * 0 や NaN が紛れうる。「有効な ID」の定義が場所ごとにズレると、
 * 「CTA は押せるのにハンドラ側で弾かれて何も起きない死にボタン」のような食い違いになるため、
 * カード側・呼び出し側の両方でこの述語を使う。
 *
 * 判定は URL のタグID解釈（`Number.isFinite(n) && n > 0`）と同じ基準に揃えている。
 */
export const hasUsableAgentId = (agent: Pick<Agent, "id">): agent is Pick<Agent, "id"> & { id: number } =>
  typeof agent.id === "number" && Number.isFinite(agent.id) && agent.id > 0;
